import { render } from "./VehiculoCreate.vue?vue&type=template&id=288fed6c&scoped=true"
import script from "./VehiculoCreate.vue?vue&type=script&lang=js"
export * from "./VehiculoCreate.vue?vue&type=script&lang=js"

import "./VehiculoCreate.vue?vue&type=style&index=0&id=288fed6c&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-288fed6c"]])

export default __exports__